import { render, staticRenderFns } from "./location-mgr.vue?vue&type=template&id=5b1ab0fc"
import script from "./location-mgr.vue?vue&type=script&lang=js"
export * from "./location-mgr.vue?vue&type=script&lang=js"
import style0 from "./location-mgr.vue?vue&type=style&index=0&id=5b1ab0fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports